import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight, Sparkles } from "lucide-react";
import Reveal from "@/components/landing/Reveal";
import { renderTitle, toFullUrl } from "@/components/landing/utils";

const DEFAULT_SUMMARY = "Rubí Perfumería es una empresa mexicana con una visión global, especializada en la comercialización de perfumes contratipo de alta calidad, líneas premium, árabe, nicho y creaciones propias innovadoras. Nuestra misión es ofrecer fragancias memorables de nicho y diseñador al alcance de todos. Estamos revolucionando el mercado con una propuesta accesible, moderna y aspiracional.";

export default function ProductoInsignia({ block, about }) {
  if (block?.visible === false) return null;
  const bottle = toFullUrl(block?.bottle_src) || block?.items?.[0]?.src || "/perfumes/dama-negro.png";
  const summary = block?.summary || about?.intro || DEFAULT_SUMMARY;
  const highlight = block?.highlight || "Somos pioneros en perfumería de alta gama a precio accesible.";
  const stats = about?.stats?.slice(0, 3) || [];
  const bg = toFullUrl(block?.bg_image);

  return (
    <section id="quienes-somos" className="bg-[#0A0A0A] on-onyx text-white py-20 md:py-32 relative overflow-hidden" data-testid="about-summary-section">
      {bg && <img src={bg} alt="" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover opacity-25" />}
      <div className="absolute inset-0 bg-gradient-to-r from-[#0A0A0A] via-[#0A0A0A]/85 to-[#0A0A0A]/40" />
      <div className="absolute inset-0 grid-lines opacity-20 pointer-events-none" />
      <div className="absolute -left-40 top-1/3 w-[520px] h-[520px] rounded-full bg-[#FFBF57]/10 blur-3xl pointer-events-none" />
      <div className="max-w-[1300px] mx-auto px-5 sm:px-6 lg:px-10 relative grid lg:grid-cols-[1.1fr_0.9fr] gap-12 lg:gap-16 items-center">
        <div>
          <Reveal><span className="eyebrow">{block?.eyebrow || "Acerca de Rubí Perfumería"}</span></Reveal>
          <Reveal delay={120}>
            <h2 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl leading-[1.02]">{renderTitle(block?.title || "Pioneros en perfumería de <em>alta gama</em> a precio accesible.")}</h2>
          </Reveal>
          <Reveal delay={220}><p className="mt-6 text-[#A1A1AA] text-base md:text-lg leading-relaxed max-w-xl">{summary}</p></Reveal>
          <Reveal delay={300}>
            <div className="mt-6 inline-flex items-center gap-2 text-sm text-[#FFBF57] border-l-2 border-[#FFBF57] pl-4 py-1"><Sparkles size={14} /> {highlight}</div>
          </Reveal>
          {stats.length > 0 && (
            <Reveal delay={380}>
              <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
                {stats.map((s, i) => (
                  <div key={i}><div className="num-mono text-2xl md:text-3xl text-white">{s.n}</div><div className="text-[10px] uppercase tracking-widest font-mono text-white/50 mt-1">{s.l}</div></div>
                ))}
              </div>
            </Reveal>
          )}
          <Reveal delay={460}>
            <Link to="/nosotros" className="btn-primary !bg-[#FFBF57] !text-[#0A0A0A] mt-10 inline-flex" data-testid="about-cta">
              Conocer Rubí Perfumería <ArrowUpRight size={16} />
            </Link>
          </Reveal>
        </div>
        <Reveal delay={200} scale>
          <div className="relative mx-auto w-[260px] sm:w-[320px] md:w-[380px] aspect-[3/4]" data-testid="about-bottle">
            <motion.div className="absolute inset-x-8 bottom-6 h-10 rounded-full bg-[#FFBF57]/30 blur-2xl" animate={{ scale: [1, 1.15, 1], opacity: [0.5, 0.8, 0.5] }} transition={{ duration: 6, repeat: Infinity, ease: "easeInOut" }} />
            <motion.img
              src={bottle} alt="Perfume Rubí" loading="lazy" decoding="async"
              className="relative w-full h-full object-contain drop-shadow-[0_40px_60px_rgba(0,0,0,0.6)]"
              animate={{ y: [0, -16, 0], rotate: [-1.5, 1.5, -1.5] }} transition={{ duration: 7, repeat: Infinity, ease: "easeInOut" }}
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
}
